var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEssentialProductRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71796 6.14689L3.56571 4.2591L5.43667 3.41776L3.56571 2.58043L2.71796 0.709473L1.87021 2.58043L-0.000745773 3.41776L1.87021 4.2591L2.71796 6.14689ZM2.71796 17.2911L3.56571 15.4201L5.43667 14.5788L3.56571 13.7415L2.71796 11.8537L1.87021 13.7415L-0.000745773 14.5788L1.87021 15.4201L2.71796 17.2911ZM10.5793 14.4217L12.2748 10.6958L16.0007 9.00028L12.2748 7.30479L10.5793 3.57889L8.88382 7.30479L5.15792 9.00028L8.88382 10.6958L10.5793 14.4217ZM10.5793 11.5916L9.76282 9.81678L7.98796 9.00028L9.76282 8.18378L10.5793 6.40893L11.3958 8.18378L13.1707 9.00028L11.3958 9.81678L10.5793 11.5916Z",
    fill: "#7F0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentialProductRed);
export default __webpack_public_path__ + "static/media/essential-product-red.68685da3.svg";
export { ForwardRef as ReactComponent };